import React, { useState, useEffect } from "react";
import { Stack, Switch, FormLabel, Flex } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditBankDetailsDrawer = ({ isOpen, onClose, bank, onUpdateBank }) => {
  const [formData, setFormData] = useState({
    bank_name: "",
    branch_name: "",
    account_number: "",
    swift_code: "",
    branch_code: "",
    is_archived: false,
  });

  useEffect(() => {
    if (bank) {
      setFormData({
        bank_name: bank.bank_name || "",
        branch_name: bank.branch_name || "",
        account_number: bank.account_number || "",
        swift_code: bank.swift_code || "",
        branch_code: bank.branch_code || "",
        is_archived: bank.is_archived || false,
      });
    }
  }, [bank]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleToggleArchive = () => {
    setFormData((prev) => ({ ...prev, is_archived: !prev.is_archived }));
  };

  const handleSubmit = () => {
    onUpdateBank({ ...bank, ...formData });
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Edit Bank Details</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Bank Name"
            name="bank_name"
            value={formData.bank_name}
            onChange={handleChange}
            placeholder="Enter bank name"
          />

          <ReusableInput
            label="Branch Name"
            name="branch_name"
            value={formData.branch_name}
            onChange={handleChange}
            placeholder="Enter branch name"
          />

          <ReusableInput
            label="Account Number"
            name="account_number"
            value={formData.account_number}
            onChange={handleChange}
            placeholder="Enter account number"
          />

          <ReusableInput
            label="Swift Code"
            name="swift_code"
            value={formData.swift_code}
            onChange={handleChange}
            placeholder="Enter SWIFT code"
          />

          <ReusableInput
            label="Branch Code"
            name="branch_code"
            value={formData.branch_code}
            onChange={handleChange}
            placeholder="Enter branch code"
          />

         
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} width="100px" height="40px">
            Cancel
          </GradientButton>
          <GradientButton onClick={handleSubmit} width="100px" height="40px">
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditBankDetailsDrawer;
